'use client';

import {motion} from 'framer-motion';
import useTopStyle from '../../utils/useTopStyle';
import heroVariants from '../../animation/heroVariants';
import Form from '../Form/Form';

const ContactsHero = () => {
  const ref = useTopStyle(72);

  return (
    <motion.section
      className='form-hero'
      ref={ref}
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={heroVariants}
    >
      <div className='container'>
        <div className='content'>
          <h2 className='title'>
            The unified platform built{' '}
            <span className='highlight'>for MSPs and MSSPs</span>
          </h2>
          <p className='lead'>
            <span className='highlight'>One</span> agent.{' '}
            <span className='highlight'>One</span> console.{' '}
            <span className='highlight'>Every</span> client secured.
          </p>
          <p className='text'>Cylerian replaces the fragmented, multi-tool stack with one AI-native platform spanning security, observability, and IT operations. Schedule a demo and see how MSPs and MSSPs secure every client from a single console, without the sprawl, blind spots, and swivel-chair work.</p>
          <p className='contact'>
            Call us:{' '}
            <span className='highlight'>
              <a href='tel:+1-833-295-7426'>+1-833-295-7426</a>
            </span>
          </p>
          <p className='contact'>
            Email us:{' '}
            <span className='highlight'>
              <a target='_top' href='mailto:info@cylerian.com'>
                info@cylerian.com
              </a>
            </span>
          </p>
        </div>
        <Form />
      </div>
    </motion.section>
  );
};

export default ContactsHero;

